module.exports = __webpack_public_path__ + "static/media/llama.a8bd00b4.md";